module.exports = __webpack_public_path__ + "img/mission-diversity-banner1.jpg?d0a661affdbab8d53bb6f77d3c1b471f";